import cn from 'classnames';
import { type FC } from 'react';
import { getSrcsetString } from 'dibs-image-utils/exports/srcSet';

// styles
import dibsCss from 'dibs-css';
import styles from './SbSharedContentModuleLandingVideo.module.css';

export const SbSharedContentModuleLandingVideo: FC<{
    id: string;
    width: number;
    height: number;
    title?: string;
    thumbnailUrl?: string;
}> = ({ id, thumbnailUrl, width, height, title }) => {
    return (
        <>
            {thumbnailUrl && (
                <img
                    alt=""
                    sizes="100vw"
                    src={thumbnailUrl}
                    srcSet={getSrcsetString(thumbnailUrl)}
                    style={{ width: width, height: height }}
                    className={cn(
                        dibsCss.top50,
                        dibsCss.left50,
                        dibsCss.border0,
                        dibsCss.absolute,
                        styles.thumbnail
                    )}
                />
            )}
            <iframe
                width={width}
                height={height}
                allow="autoplay"
                className={cn(
                    dibsCss.top50,
                    dibsCss.left50,
                    dibsCss.border0,
                    dibsCss.absolute,
                    styles.iframe
                )}
                title={`${title || ''}_${id.toString()}`}
                referrerPolicy="strict-origin-when-cross-origin"
                src={`https://player.vimeo.com/video/${id}?badge=0&background=1&player_id=0&app_id=143881`}
            />
        </>
    );
};
